import { mods } from '@approvalmax/theme';
import { Grid } from '@approvalmax/ui/src/components';
import type { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const GridReversable = styled(Grid)<StyledMods<{ reverse: boolean }>>`
    ${mods('reverse', true)`
        & > *:nth-child(1),
        & > *:nth-child(2) {
            order: 2;
        }

        & > *:nth-child(3),
        & > *:nth-child(4) {
            order: 1;
        }
    `};
`;
